<template>
  <v-card v-if="inmuebleDatos">
    <v-toolbar card>
      <v-icon>domain</v-icon>
      <v-toolbar-title class="font-weight-light">Datos Inmueble</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="px-5 blue--text">
      <v-flex xs12>
        <v-text-field label="Dirección" v-model="inmuebleDatos.direccion"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-layout row justify-space-between>
          <v-flex xs3>
            <v-text-field label="Escalera" v-model="inmuebleDatos.escalera"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field label="Piso" v-model="inmuebleDatos.piso"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field label="Letra" v-model="inmuebleDatos.letra"></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-text-field label="Uso" v-model="inmuebleDatos.uso"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-layout row justify-space-between>
          <v-flex xs3>
            <v-text-field suffix="m2" label="Superficie" v-model="inmuebleDatos.superficie"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field suffix="%" label="Cuota" v-model="inmuebleDatos.cuota"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field suffix="Año" label="Antigüedad" v-model="inmuebleDatos.year"></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-checkbox
          slot="activator"
          class="py-0"
          label="¿Participa?"
          v-model="inmuebleDatos.participa"
        ></v-checkbox>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click.stop="inmuebleDatosUpdate">
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
    <template v-if="debug">
      <pre>{{inmuebleDatos}}</pre>
    </template>
  </v-card>
</template>

<script>
export default {
  props: ["inmueble", "refCatastral", "idInmueble", "debug"],
  data () {
    return {
      inmuebleDatos: null,
      hecho: false
    }
  },

  mounted() {
    this.inmuebleDatos = Object.assign({}, this.inmueble);
  },

  watch: {
    inmueble() {
      this.inmuebleDatos = Object.assign({}, this.inmueble);
    }
  },

  methods: {
    inmuebleDatosUpdate() {
      const payload = {
        refCatastral: this.refCatastral,
        idInmueble: this.idInmueble,
        inmuebleDatos: this.inmuebleDatos
      };
      this.$store.dispatch("inmuebleDatosUpdate", payload);
      this.$emit("listo");
      // this.hecho = true;
    }
  }
}
</script>
